/** CRM-3 Communications — storico WhatsApp/Email globale */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Loader2, MessageCircle, Send } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const STATO_ICON = {
  queued: "⏳", sent: "✓", delivered: "✓✓", read: "👁",
  failed: "✗", received: "↙",
};

export default function CRMCommunicationsPage() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [tipoF, setTipoF] = useState("");
  const [testMode, setTestMode] = useState(true);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (tipoF) params.set("tipo", tipoF);
      const r = await axios.get(`${API}/api/admin/crm/communications?${params.toString()}`, { withCredentials: true });
      setItems(r.data.items || []); setTotal(r.data.total || 0);
      setTestMode(r.data.test_mode);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [tipoF]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-4 md:p-6" data-testid="crm-communications-page">
      <div className="flex justify-between mb-4">
        <div>
          <h2 className="text-xl font-semibold flex items-center gap-2"><MessageCircle className="w-5 h-5" /> Comunicazioni ({total})</h2>
          {testMode && <p className="text-xs text-amber-600">⚠ TEST_MODE Spoki attivo</p>}
        </div>
        <a href={`${API}/api/admin/crm/export/communications?format=xlsx`} target="_blank" rel="noreferrer"
           data-testid="crm-communications-export-btn"
           className="px-3 py-2 text-xs rounded bg-emerald-100 text-emerald-700 hover:bg-emerald-200 self-start">Export</a>
      </div>
      <select value={tipoF} onChange={(e) => setTipoF(e.target.value)} className="mb-3 px-2 py-2 text-sm rounded border border-zinc-200">
        <option value="">Tutti i tipi</option>
        <option value="whatsapp_out">WhatsApp out</option>
        <option value="whatsapp_in">WhatsApp in</option>
        <option value="email_out">Email out</option>
        <option value="manuale_note">Note manuali</option>
      </select>
      {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> :
       items.length === 0 ? <p className="text-zinc-400 italic text-center py-6">Nessuna comunicazione</p> :
        <div className="space-y-2">
          {items.map((c) => (
            <div key={c.id} className="border border-zinc-200 rounded p-3" data-testid={`crm-comm-${c.id}`}>
              <p className="flex justify-between text-xs text-zinc-500">
                <span>{c.tipo} · {c.canale} · {c.ts_send?.slice(0, 16).replace("T", " ")}</span>
                <span>{STATO_ICON[c.stato] || ""} {c.stato}</span>
              </p>
              <p className="text-sm mt-1">{c.contenuto_text}</p>
              {c.telefono_destinatario && <p className="text-xs text-zinc-400 mt-1">→ {c.telefono_destinatario}</p>}
            </div>
          ))}
        </div>}
    </div>
  );
}
